export default __webpack_public_path__ + "static/media/Facet lines.af0d4929.png";